import { DELETE_SCHOOL_ENDPOINT } from "../../constants/ApiConstants";
import Error from "../../helpers/Error";
import axios from "axios";

export default async function deleteSchoolCall(id: number) {
    try {
        const response = await axios.delete(DELETE_SCHOOL_ENDPOINT + id);
        return response.data;
    } catch (error: any) {
        throw new Error(error.response.data.message, error.response.data.code);
    }
}
